
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.832 12.5h-5V3.335h13.333v9.167h-5m-3.333 0v4.166m0-4.166h3.333m-3.333 4.166h3.333m-3.333 0H7.165h5m0 0v-4.166m0 4.166h1.667","stroke":"#748190","stroke-width":".833","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    